<div [class]="'s__timeline-block s__timeline-block--' + variant()">
  @for (block of trustedBlocks(); track $index) {
    <div class="s__timeline-block__block">
      <div class="s__timeline-block__dot" aria-hidden="true"></div>
      @if (block.overline) {
        <ds-overline [text]="block.overline" />
      }
      <h3 class="s__timeline-block__heading">{{ block.heading }}</h3>
      <div class="s__timeline-block__body" [innerHTML]="block.trustedBody"></div>
      @if (block.imageSrc) {
        <figure class="s__timeline-block__figure">
          <img
            [ngSrc]="block.imageSrc"
            [width]="block.imageWidth || 800"
            [height]="block.imageHeight || 600"
            [alt]="block.imageAlt ?? ''"
            sizes="(min-width: 768px) 50vw, 100vw"
          />
        </figure>
      }
    </div>
  }
</div>
